export const TZ = "America/Chicago";

export const SERVICES = [
  { value: "standard", label: "Standard" },
  { value: "airport", label: "Airport" },
  { value: "nashville_express", label: "Nashville Express" },
  { value: "custom_long_distance", label: "Custom Long Distance" },
];
export const SERVICE_LABEL: Record<string, string> = Object.fromEntries(SERVICES.map((s) => [s.value, s.label]));

export const TRIP_TYPES = [
  { value: "one_way", label: "One way" },
  { value: "round_trip", label: "Round trip" },
];

export const STAGES = [
  { value: "requested", label: "Requested" },
  { value: "quoted", label: "Quoted" },
  { value: "agreement_pending", label: "Agreement pending" },
  { value: "approved", label: "Approved" },
  { value: "payment_verified", label: "Payment verified" },
  { value: "confirmed", label: "Confirmed" },
  { value: "completed", label: "Completed" },
];
export const TERMINAL = [
  { value: "cancelled", label: "Cancelled" },
  { value: "no_show", label: "No-show" },
  { value: "declined", label: "Declined" },
];

export const METHODS = [
  { value: "zelle", label: "Zelle" },
  { value: "apple_pay", label: "Apple Pay" },
  { value: "venmo", label: "Venmo" },
  { value: "paypal", label: "PayPal" },
  { value: "cash", label: "Cash" },
  { value: "other", label: "Other" },
];
export const METHOD_LABEL: Record<string, string> = Object.fromEntries(METHODS.map((m) => [m.value, m.label]));

export const usd = (n?: number | null) =>
  n == null ? "—" : n.toLocaleString("en-US", { style: "currency", currency: "USD" });

export const ct = (iso?: string | null) =>
  iso
    ? new Date(iso).toLocaleString("en-US", {
        timeZone: TZ, weekday: "short", month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit",
      }) + " CT"
    : "—";

export const todayCentral = () => new Intl.DateTimeFormat("en-CA", { timeZone: TZ }).format(new Date());

export const centralParts = (iso: string) => {
  const d = new Date(iso);
  return {
    date: new Intl.DateTimeFormat("en-CA", { timeZone: TZ }).format(d),
    time: d.toLocaleTimeString("en-US", { timeZone: TZ, hour: "numeric", minute: "2-digit" }).replace(/\s/g, " "),
  };
};

export const prettyPhone = (p?: string) => {
  const m = (p || "").match(/^\+1(\d{3})(\d{3})(\d{4})$/);
  return m ? `(${m[1]}) ${m[2]}-${m[3]}` : p || "";
};

export const smsHref = (phone: string, body: string) => `sms:${phone}?&body=${encodeURIComponent(body)}`;
